<template>

  <div class="app" v-if="isAuthenticated">
    <Header/>
    <div class="app__main">
      <EventMenu v-if="!isLoading" :user-role-name="userRoleName" class="app__menu"/>

      <div class="app__content">
        <div v-show="isLoading" id="loading">
          <Loader/>
        </div>

        <router-view></router-view>
      </div>
    </div>
  </div>
  <div class="app" v-else>
    <router-view></router-view>
  </div>

</template>

<script>
import {mapState} from 'vuex'
import {mapGetters} from 'vuex'
import ClickOutside from 'vue-click-outside'

import Loader from '@/components/Global/Loader'
import Header from '@/components/Layouts/Header/Header'
import EventMenu from '@/components/Layouts/EventMenu/IndexMenu'

import {UserInfo} from '@/controllers/UserInfo'

import VueCookie from 'vue-cookie'
import Login from '@/views/auth/Login'

// import Options from '@/components/Admin/Options'

export default {
  name: 'App',
  components: {
    Loader,
    Header,
    EventMenu,

  },
  async beforeCreate() {
  },
  async created() {
  },
  data: function () {
    return {
      userRoleName: 'visitor',

    }
  },
  props: [],

  mounted() {

    if (typeof this.getToken !== 'undefined') {
      this.userRole = this.getUserRole(this.getToken).then((result) => {
        this.userRoleName = result.name
      })
    }

  },
  updated() {
  },
  watch: {
    'getToken': function (val) {
      console.log('getToken val is', val)

      if (typeof val !== 'undefined') {
        this.userRole = this.getUserRole(this.getToken).then((result) => {
          this.userRoleName = result.name

        })
      }
    },
  },
  methods: {},

  computed: {
    ...mapState({
      env: 'env',
    }),

    ...mapGetters({
      isLoading: 'isLoading',
      isAuthenticated: 'authentication/isAuthenticated',
      user: 'user/get',
      getToken: 'authentication/get',
    }),
  },

  directives: {
    ClickOutside,
  },
}
</script>
np
<style lang="scss" scoped>

.app {
  &__main {
    display: flex;
  }

  &__menu {
    position: relative;
    min-height: calc(100vh - 90px);
    width: 255px;
    background-color: #282527;
    padding: 0 30px 50px 30px;
  }

  &__content {
    position: relative;
    flex-grow: 1;
    padding-bottom: 40px;
  }
}
</style>
